<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="品类名称：">
            <el-input size="medium" v-model="searchForm.category" clearable></el-input>
          </el-form-item>
          <el-form-item label="编码：">
            <el-input size="medium" v-model="searchForm.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="searchTable()">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button v-show="fun_dic[1002301]" size="medium" @click="addCategory">新增品类</el-button>
        <el-button style="margin-left:0" size="medium" @click="addCategory">新增品类</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="ID" label="品类ID"></el-table-column>
          <el-table-column prop="CODE" label="编码"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="名称"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button v-show="fun_dic[1002302]" type="text" size="small" icon="el-icon-view"
                @click="detailData(scope.row)" v-if="Number(catalogNum) > 2">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="detailData(scope.row)"
                v-if="Number(catalogNum) > 2">查看</el-button>
              <el-button v-show="fun_dic[1002303]" type="text" size="small" icon="el-icon-edit"
                @click="updateData(scope.row)">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-edit" @click="updateData(scope.row)">修改</el-button>
              <el-button type="text" size="small" @click="deleteCatalog(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="修改信息" center :visible.sync="updateFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="updateForm" ref="updateForm" size="small" :rules="rules">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="CATALOG_NAME">
          <label slot="label">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="updateForm.CATALOG_NAME" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('updateForm')">取 消</el-button>
        <el-button size="small" @click="submitUpdate('updateForm')" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增品类" center :visible.sync="addFormVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" size="small" :rules="rules">
        <el-form-item label="编码：" :label-width="formLabelWidth" prop="code">
          <label slot="label">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码：</label>
          <el-input v-model="addForm.code" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="name">
          <label slot="label">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="addForm.name" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('addForm')">取 消</el-button>
        <el-button size="small" @click="submitAdd('addForm')" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  addCategory, quueryCategory, updateFun, delCatalogFun,
} from '@/assets/api/skuManage';
import { frontEndFun } from '@/assets/api/frontFun';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      PAGE_ID: '10023', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1002301: 0, 1002302: 0, 1002303: 0 },
      rules: {
        CATALOG_NAME: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
      },
      category_name: sessionStorage.getItem('category_name'),
      formLabelWidth: '120px',
      updateForm: {},
      updateFormVisible: false,
      loading: false,
      searchForm: {},
      addFormVisible: false,
      addForm: {},
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      catalog_list: [
        {
          ID: 2,
          NAME: '二类',
        },
      ],
      catalogNum: sessionStorage.getItem('catalogNum'),
    };
  },
  created() {
    if (this.SECOND_CATEGORY_DATA_CONDITION.CONDITION) {
      this.searchForm = this.SECOND_CATEGORY_DATA_CONDITION.CONDITION;
      this.tableData = this.SECOND_CATEGORY_DATA_CONDITION.DATA;
      this.currentPage = this.SECOND_CATEGORY_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryBeforeFun();
    this.queryTable();
  },
  computed: {
    SECOND_CATEGORY_DATA_CONDITION() {
      return this.$store.state.SECOND_CATEGORY_DATA_CONDITION;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 查看
    detailData(row) {
      this.$router.push({ name: 'thirdCategory' });
      sessionStorage.setItem('th_p_id', row.ID);
      sessionStorage.setItem('second_name', row.CATALOG_NAME);
    },
    // 筛选
    searchTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    // 拉取
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        P_ID: Number(sessionStorage.getItem('sec_p_id')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
        CATALOG_LEVEL: 2,
      };
      if (this.searchForm.code) {
        params.CODE = parseInt(this.searchForm.code);
      }
      if (this.searchForm.category) {
        params.NAME = this.searchForm.category;
      }
      quueryCategory(params).then((result) => {
        if (result.length) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addCategory() {
      this.addFormVisible = true;
    },
    // 取消
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.queryTable();
    },
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            CATALOG_CODE: this.addForm.code ? parseInt(this.addForm.code) : '',
            CATALOG_NAME: this.addForm.name,
            CATALOG_LEVEL: 2,
            P_ID: Number(sessionStorage.getItem('sec_p_id')),
          };
          addCategory(params)
            .then((result) => {
              this.$message.show({ text: '新增成功', type: 'success' });
              this.addForm = {};
              this.queryTable();
              this.addFormVisible = false;
              this.loading = false;
            }).catch((error) => {
              this.loading = false;
              this.$message.show({ text: error, type: 'error' });
            });
        }
      });
    },
    // 修改
    updateData(row) {
      this.updateForm = row;
      const tmpName = row.CATALOG_NAME.split('/');
      this.updateForm.CATALOG_NAME = tmpName[1];
      this.updateFormVisible = true;
    },
    submitUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            CATALOG_ID: this.updateForm.ID,
            CATALOG_NAME: this.updateForm.CATALOG_NAME,
          };
          this.loading = true;
          updateFun(params)
            .then((result) => {
              this.$message.show({ text: '修改成功', type: 'success' });
              this.updateFormVisible = false;
              this.loading = false;
              this.queryTable();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.loading = false;
            });
        }
      });
    },
    deleteCatalog(row) {
      this.$confirm('此操作将删除分类下全部产品，并且会将分类下产品从采购列表中下架，不能继续采购, 是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          CATALOG_ID: row.ID,
        };
        delCatalogFun(params).then((result) => {
          this.$message.show({
            text: '删除品类成功',
            type: 'success',
          });
          this.queryTable();
        })
          .catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
          });
      }).catch(() => {
        this.$message.show({
          text: '取消操作',
          type: 'warning',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/secondCategory.vue